import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */
export default function BarApexChart({ name, data }) {
  const [idname] = useState(name);
  const [renderChart, setRenderChart] = useState(false);
  const options = {
    series: [
      {
        data: data?.value,
      },
    ],
    chart: {
      type: 'bar',
      height: data?.value.length > 25 ? 1100 : 450,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: data?.label,
    },
  };

  useEffect(() => {
    if (renderChart) {
      const chart = new ApexCharts(document.querySelector(`#${idname}`), options);
      chart.render();
    }

    setRenderChart(true);
  }, [renderChart]);

  return (
    <Box
      sx={
        data?.value.length > 25
          ? { height: '465px', overflowY: 'scroll', overflowX: 'hidden' }
          : { height: '465px' }
      }
    >
      <div id={idname} />
    </Box>
  );
}
